import React from 'react';

const BYDAPremiumFeaturesInfo: React.FC = () => {
  return (
    <div className="premium-features">
      <label>
        Enabling BYDA Premium Features will allow user to lodge enquiries from
        SmarterWX Locate under the following conditions:
      </label>
      <ol className="list">
        <li>
          1. The user must register as a BYDA Member and authorised to use the
          BYDA API.{' '}
        </li>
        <li>
          2. The master admin account must be linked with BYDA through SmarterWX
          Locate.
        </li>
      </ol>
    </div>
  );
};

export default React.memo(BYDAPremiumFeaturesInfo);
